import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {getDealers} from '../../store/dealers/actions';
import {useFormContext} from 'react-hook-form';

const ListDealers = ({
  data,
  initialSelect,
  getDealers,
  name = 'dealer',
  required = true,
  disabled = false,
  className = '',
}) => {
  const [loading, setLoading] = useState(false);
  const {register, setValue, watch, formState: {errors}} = useFormContext();

  const selected = watch(name) || '';

  useEffect(() => {
    setLoading(true);
    getDealers();
    setLoading(false);
  }, [getDealers]);

  const options = data?.map((dealer) => ({
    value: dealer.id,
    label: dealer.name,
  })) || [];

  // InitialSelect setzen
  useEffect(() => {
    if (initialSelect && options.length > 0) {
      const found = options.find((d) => d.value === initialSelect.id);
      if (found) {
        setValue(name, found.value, {shouldValidate: true});
      }
    }
  }, [initialSelect, options, name, setValue]);

  return (
    <>
      <select
        className={`form-control ${className} ${errors[name] ? 'is-invalid' : ''}`}
        {...register(name, {
          required: required ? 'Please select an option' : false,
        })}
        value={selected}
        disabled={disabled}
      >
        <option value="">Select dealer{required && ' *'}</option>
        {loading && <option disabled>Loading...</option>}
        {options.map((d) => (
          <option key={d.value} value={d.value}>
            {d.label}
          </option>
        ))}
      </select>
      {errors[name] && (
        <div className="invalid-feedback">{errors[name]?.message}</div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  data: state.Dealers.data,
});

export default connect(mapStateToProps, {getDealers})(ListDealers);
